namespace $.$$ {
	$mol_style_define($easyreels_user_signin, {
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.block,
	})
}
